//@flow

export const FINAL_RESULT_COLUMN_ID = "final_result";
export const RESULT_PAGE_SPECIAL_COLUMN = "resultPageSpecialColumn";
export const LEGACY_RESPONSE_DISPLAY_VALUE = "Not captured";
export const LEGACY_RESPONSE_TOOLTIP =
  "This value was not stored for this response. The response may have been submitted before this value existed or before storage was supported.";
export const MISSING_CALCULATOR_RESULT_DISPLAY_VALUE = "Not in this response";
export const MISSING_CALCULATOR_RESULT_TOOLTIP =
  "This calculator result was not stored with this response. It may have been added after the response was submitted.";
